<template>
  <nav class="login-reminder flex justify-center items-center space-x-4 py-5 border-y border-y-gray-200">
    <!-- Login and Register Links (for not logged in users) -->
    <router-link v-if="!isLoggedIn" :to="`/${$systemPath('login')}`"
      class="flex items-center space-x-2 text-blue-500 hover:text-blue-700 transition pr-4">
      <font-awesome-icon class="login-icon" :class="['text-lg', [getColor(500, 'text'), getColor(400, 'hover:text')]]"
        :icon="['fas', 'user']" />
      <span class="login-span" :class="['text-lg', [getColor(500, 'text'), getColor(400, 'hover:text')]]">{{
        $translate('Login') }}</span>
    </router-link>
    <router-link v-if="!isLoggedIn" :to="`/${$systemPath('register')}`"
      class="login-reminder-register flex items-center space-x-2 text-blue-500 hover:text-blue-700 transition pl-4">
      <font-awesome-icon class="register-icon"
        :class="['text-lg', [getColor(500, 'text'), getColor(400, 'hover:text')]]" :icon="['fas', 'user-plus']" />
      <span class="register-span" :class="['text-lg', [getColor(500, 'text'), getColor(400, 'hover:text')]]">{{
        $translate('Register') }}</span>
    </router-link>

    <!-- User Info (for logged in users) -->
    <div v-if="isLoggedIn" class="user-card flex items-center space-x-4">
      <img :src="user.avatar" alt="User Avatar" class="w-10 h-10 rounded-full" />
      <div class="flex flex-col">
        <div class="flex items-center space-x-2">
          <span :class="[[getColor(600, 'text')]]">{{ user.full_name }}</span>
          <span v-if="user.membership" class="membership-badge">{{ user.membership }}</span>
          <span v-if="!user.membership" class="membership-badge">PLUS</span>
        </div>
        <div class="logout flex items-center space-x-2 cursor-pointer text-xs" :class="[[getColor(300, 'text')]]"
          @click="handleLogout" :title="$translate('Logout')">
          <font-awesome-icon :icon="['fas', 'unlock']" class="logout-icon" />
          <span>{{ $translate('Logout') }}</span>
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
import { getUserData, logout } from '@/utils/cookie';
import { getColorClass } from '@/utils/helper';



// Emit 'no-content' if user is not logged in
export default {
  name: 'AuthModule',
  props: {
    event: {
      type: Object,
      required: false,
    },
    attendee: {
      type: Object,
      required: false,
    },
    isSignedUp: {
      type: Boolean,
      required: false,
    },
    eventType: {
      type: Object,
      required: false,
    },
  },
  setup(props) {
    const getColor = (shade = 500, prefix = 'bg') => {
      if (props.eventType && props.eventType.type) {
        return getColorClass(props.eventType.type, shade, prefix);
      }
      return getColorClass('default', shade, prefix);
    };

    // Access props values
    const attendeeName = props.attendee ? props.attendee.name : 'Guest';
    const eventName = props.event ? props.event.name : 'Unknown Event';

    return { getColor, attendeeName, eventName };
  },
  data() {
    return {
      isLoggedIn: false,
      user: {},
    };
  },
  methods: {
    handleLogout() {
      logout();
      this.isLoggedIn = false;
      this.user = {};
    },
  },
  mounted() {
    const user = getUserData();
    if (user) {
      this.isLoggedIn = true;
      this.user = user;
    } else {
      this.$emit('no-content');
    }
  },
};

</script>

<style scoped>
.login-reminder a {
  color: #ddd;
  font-size: 0.8rem;
}

.login-reminder a:hover {
  color: #fff;
}

.user-card {
  color: #ddd;
}

.user-card img {
  width: 2.5rem;
  height: 2.5rem;
  border-radius: 50%;
}

.membership-badge {
  background-color: #4CAF50;
  color: white;
  font-size: 0.6rem;
  padding: 0.2rem 0.4rem;
  border-radius: 0.3rem;
  margin-left: 0.5rem;
}

.logout {
  color: rgb(6 182 212);
  display: flex;
  align-items: center;
}

.logout-icon {
  font-size: 0.7rem;
}

.logout:hover .logout-icon {
  color: rgb(252 165 165);
}

.logout:hover span {
  color: rgb(252 165 165);
}

@media (max-width: 370px) {
  .login-reminder-register {
    padding-left: 0px;
    margin: 10px 0px;
  }
}

@media (max-width:391px) {

  .login-icon,
  .login-span,
  .register-icon,
  .register-span {
    font-size: 1rem;
    line-height: 1.5rem;
  }
}
</style>
